import { ConcreteEncodable } from "./ConcreteEncodable";

import { StrategyAmendModificationLockResponseImplEncoder } from "../../encoder/StrategyAmendModificationLockResponseImplEncoder";

import * as CubiqTS from "../../index";
import { StrategyAmendModificationLockResponse } from "../StrategyAmendModificationLockResponse";

export class StrategyAmendModificationLockResponseImpl
  extends ConcreteEncodable
  implements StrategyAmendModificationLockResponse
{
  public static enType: string = "com.bcdfx.model.StrategyAmendModificationLockResponseImpl";

  /*FID=1*/
  public lockErrors: CubiqTS.Errors | null = null;
  /*FID=2*/
  public orderData: Array<CubiqTS.OrderData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StrategyAmendModificationLockResponseImplEncoder.Instance;
    this.setEncodableType(StrategyAmendModificationLockResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StrategyAmendModificationLockResponseImpl[" +
      "lockErrors=" +
      this.lockErrors +
      "orderData=" +
      this.orderData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
